import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function TransactionsIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (
    <Svg
      {...svgProps}
      viewBox="0 0 485.211 485.211"
    >
      <G fill={color}>
        <Path d="M378.834,331.597c3.467,5.867,5.213,12.709,5.213,20.55c0,12.031-3.584,22.038-10.748,30.065
    c-7.174,8.027-17.502,12.764-31.041,14.183v20.582h-17.235v-20.493c-22.533-2.314-36.482-15.434-41.873-39.302l26.648-6.954
    c2.46,15.015,10.637,22.533,24.521,22.533c6.487,0,11.285-1.596,14.337-4.83c3.053-3.221,4.593-7.076,4.593-11.636
    c0-4.714-1.54-8.293-4.593-10.692c-3.052-2.427-9.861-5.502-20.404-9.235c-9.475-3.286-16.881-6.521-22.215-9.773
    c-5.326-3.201-9.652-7.673-12.966-13.45c-3.351-5.802-5.008-12.555-5.008-20.228c0-10.071,2.992-19.158,8.914-27.218
    c5.955-8.051,15.28-12.966,28.045-14.771v-15.903h17.235v15.903c19.252,2.311,31.75,13.208,37.439,32.692l-23.788,9.74
    c-4.616-13.353-11.757-20.045-21.469-20.045c-4.858,0-8.765,1.479-11.7,4.472c-2.959,2.991-4.438,6.604-4.438,10.869
    c0,4.326,1.419,7.64,4.261,9.979c2.848,2.31,8.914,5.185,18.244,8.587c10.221,3.733,18.276,7.285,24.077,10.604
    C370.718,321.147,375.338,325.763,378.834,331.597z M485.211,325.997c0,83.755-67.874,151.633-151.625,151.633
    c-83.755,0-151.631-67.878-151.631-151.633c0-83.749,67.876-151.627,151.631-151.627
    C417.337,174.37,485.211,242.248,485.211,325.997z M454.889,325.997c0-66.898-54.404-121.3-121.303-121.3
    c-66.897,0-121.304,54.402-121.304,121.3c0,66.902,54.406,121.307,121.304,121.307
    C400.484,447.304,454.889,392.899,454.889,325.997z M242.606,53.068h181.955c8.382,0,15.159-5.096,15.159-11.374V18.949
    c0-6.277-6.777-11.369-15.159-11.369H242.606c-8.382,0-15.164,5.092-15.164,11.369v22.745
    C227.443,47.972,234.224,53.068,242.606,53.068z M242.606,113.719h181.955c8.382,0,15.159-5.094,15.159-11.372V79.603
    c0-6.279-6.777-11.374-15.159-11.374H242.606c-8.382,0-15.164,5.094-15.164,11.374v22.745
    C227.443,108.625,234.224,113.719,242.606,113.719z M15.161,416.977h178.816c-9.061-13.861-16.08-29.174-20.729-45.49H15.161
    C6.781,371.486,0,376.578,0,382.865v22.737C0,411.88,6.781,416.977,15.161,416.977z M197.116,432.14H15.161
    C6.781,432.14,0,437.231,0,443.509v22.747c0,6.277,6.781,11.374,15.161,11.374h181.955c8.382,0,15.166-5.097,15.166-11.374v-22.747
    C212.282,437.231,205.499,432.14,197.116,432.14z M15.161,356.328h154.534c-1.836-9.862-2.9-19.961-2.9-30.331
    c0-5.12,0.294-10.156,0.768-15.159H15.161C6.781,310.838,0,315.93,0,322.212v22.737C0,351.236,6.781,356.328,15.161,356.328z
     M242.606,174.37h21.912c21.058-9.654,44.393-15.163,69.067-15.163c24.633,0,48.006,5.509,69.06,15.163h21.916
    c8.382,0,15.159-5.094,15.159-11.371v-22.745c0-6.277-6.777-11.374-15.159-11.374H242.606c-8.382,0-15.164,5.097-15.164,11.374
    v22.745C227.443,169.276,234.224,174.37,242.606,174.37z M15.161,174.37h181.955c8.382,0,15.166-5.094,15.166-11.371v-22.745
    c0-6.277-6.784-11.374-15.166-11.374H15.161C6.781,128.88,0,133.977,0,140.254v22.745C0,169.276,6.781,174.37,15.161,174.37z
     M15.161,295.675h154.534c2.961-16.111,8.263-31.363,15.521-45.49H15.161C6.781,250.185,0,255.276,0,261.554v22.752
    C0,290.583,6.781,295.675,15.161,295.675z M15.161,235.023h178.816c5.391-8.291,11.551-15.992,18.305-23.16v-10.958
    c0-6.277-6.781-11.369-15.161-11.369H15.161C6.781,189.536,0,194.627,0,200.905v22.745C0,229.927,6.781,235.023,15.161,235.023z"/>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
    </Svg>
  );
}

TransactionsIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

TransactionsIcon.defaultProps = {
  height: 21,
  width: 32,
  color: '#FFFFFF',
};

export default pure(TransactionsIcon);
